import { REFRESH_DATABASE, REFRESH_DATABASE_SUCCESS, REFRESH_DATABASE_FAILURE } from "../../store/constants/database";

const initialState = {
  isLoaded: false,
  isLoading: false,
  timestamp: null,
  datetime: null,
  error: false,
  errorDescription: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case REFRESH_DATABASE:
      return {
        ...state,
        isLoading: true
      };
    case REFRESH_DATABASE_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        timestamp: Math.floor(new Date() / 1000),
        datetime: new Date().toISOString().slice(0, 19).replace('T', ' '),
      };
    case REFRESH_DATABASE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorDescription: action.error
      };
    default:
      return state;
  }
}
